'use strict';

var _slicedToArray = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./HeaderNew.css');

var _finbLogo = require('./img/finb-logo.svg');

var _finbLogo2 = _interopRequireDefault(_finbLogo);

var _linkedin = require('./img/linkedin.svg');

var _linkedin2 = _interopRequireDefault(_linkedin);

var _fcb = require('./img/fcb.svg');

var _fcb2 = _interopRequireDefault(_fcb);

var _insta = require('./img/insta.svg');

var _insta2 = _interopRequireDefault(_insta);

var _useScreenSize = require('../../hoc/useScreenSize');

var _useScreenSize2 = _interopRequireDefault(_useScreenSize);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeaderNew = function HeaderNew() {
  var _ref = (0, _react.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      opened = _ref2[0],
      setOpened = _ref2[1];

  var _ref3 = (0, _useScreenSize2.default)(),
      isMobile = _ref3.isMobile,
      isTablet = _ref3.isTablet;

  var handleNavigation = function handleNavigation() {
    window.location.href = "/roles";
  };

  var toggleMenu = function toggleMenu() {
    setOpened(function (prev) {
      return !prev;
    });
  };

  var handleGoToHomepage = function handleGoToHomepage() {
    window.location.href = "/";
  };

  return _react2.default.createElement('div', {
    className: 'header'
  }, _react2.default.createElement('div', {
    className: 'header-content'
  }, _react2.default.createElement('div', {
    className: 'logo',
    onClick: handleGoToHomepage
  }, _react2.default.createElement('img', {
    src: _finbLogo2.default,
    alt: ''
  })), !isMobile && !isTablet && _react2.default.createElement('div', {
    className: 'header-links'
  }, _react2.default.createElement('a', {
    href: '/marketplace',
    className: 'header-link'
  }, 'Marketplace'), _react2.default.createElement('a', {
    href: '/strategic-partners',
    className: 'header-link'
  }, 'Strategic Partners'), _react2.default.createElement('a', {
    href: '/about',
    className: 'header-link'
  }, 'About'))), !isMobile && !isTablet && _react2.default.createElement('div', {
    className: 'header-actions'
  }, _react2.default.createElement('a', {
    href: '/login',
    className: 'header-link'
  }, 'Login'), _react2.default.createElement('button', {
    className: 'global-button web-btn',
    onClick: handleNavigation
  }, 'Get Started')), (isMobile || isTablet) && _react2.default.createElement('div', null, _react2.default.createElement('div', {
    className: 'burger-menu',
    onClick: toggleMenu
  }, _react2.default.createElement('div', {
    className: (0, _classnames2.default)('tham', 'tham-e-squeeze', 'tham-w-6', {
      'tham-active': opened
    })
  }, _react2.default.createElement('div', {
    className: 'tham-box'
  }, _react2.default.createElement('div', {
    className: 'tham-inner'
  }), _react2.default.createElement('div', {
    className: 'tham-inner'
  }), _react2.default.createElement('div', {
    className: 'tham-inner'
  })))), opened && _react2.default.createElement('div', {
    className: 'mobile-menu'
  }, _react2.default.createElement('div', {
    className: 'mobile-links'
  }, _react2.default.createElement('div', {
    className: 'first-section'
  }, _react2.default.createElement('a', {
    href: '/marketplace',
    className: 'header-mobile-link'
  }, 'Marketplace'), _react2.default.createElement('a', {
    href: '/strategic-partners',
    className: 'header-mobile-link'
  }, 'Strategic Partners'), _react2.default.createElement('a', {
    href: '/about',
    className: 'header-mobile-link'
  }, 'About')), _react2.default.createElement('div', {
    className: 'line'
  }), _react2.default.createElement('a', {
    href: '/login',
    className: 'header-mobile-link login'
  }, 'Login'), _react2.default.createElement('button', {
    className: 'global-button mobile-button',
    onClick: handleNavigation
  }, 'Get Started'), _react2.default.createElement('div', {
    className: 'line'
  }), _react2.default.createElement('div', {
    className: 'third-section'
  }, _react2.default.createElement('a', {
    href: '/terms',
    className: 'header-mobile-link-small'
  }, 'Terms of Service'), _react2.default.createElement('a', {
    href: '/privacy',
    className: 'header-mobile-link-small'
  }, 'Privacy Policy'), _react2.default.createElement('a', {
    href: '/cookie',
    className: 'header-mobile-link-small'
  }, 'Cookies')), _react2.default.createElement('div', {
    className: 'line'
  }), _react2.default.createElement('div', {
    className: 'socials-section'
  }, _react2.default.createElement('a', {
    className: 'header-mobile-link-small',
    href: 'javascript:void(0)'
  }, 'Socials'), _react2.default.createElement('div', {
    className: 'socials-icons'
  }, _react2.default.createElement('a', {
    href: 'https://www.facebook.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, _react2.default.createElement('img', {
    src: _fcb2.default,
    alt: '',
    className: 'social-icon'
  })), _react2.default.createElement('a', {
    href: 'https://www.linkedin.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, _react2.default.createElement('img', {
    src: _linkedin2.default,
    alt: '',
    className: 'social-icon'
  })), _react2.default.createElement('a', {
    href: 'https://www.instagram.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, _react2.default.createElement('img', {
    src: _insta2.default,
    alt: '',
    className: 'social-icon'
  }))))))));
};

exports.default = HeaderNew;